import React from "react"
import { useTranslation } from "react-i18next"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"

export interface DeleteAddonOverlayViewModel {
  addonName?: string
  closeOverlay: () => void
  deleteAddon: () => void
}

export const DeleteAddonOverlayView = React.memo(
  ({ closeOverlay, deleteAddon, addonName }: DeleteAddonOverlayViewModel) => {
    const { t } = useTranslation()

    return (
      <ConfirmationOverlay.Root id="delete-addon-overlay" isDanger>
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>
            {t("Product.Configuration.Addon.Delete")}
          </ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Message>
          {t("Product.Configuration.Addon.DeleteConfirmationMessage", {
            addon: addonName
          })}
        </ConfirmationOverlay.Message>
        <ConfirmationOverlay.Actions>
          <ConfirmationOverlay.Cancel onClick={closeOverlay} />
          <ConfirmationOverlay.Submit onClick={deleteAddon}>
            {t("General.Delete")}
          </ConfirmationOverlay.Submit>
        </ConfirmationOverlay.Actions>
      </ConfirmationOverlay.Root>
    )
  }
)
